<template>
  <v-container justify="center">
    <v-row justify="center">
      <h2>Moje objednávky</h2>
    </v-row>
    <v-row justify="center" align="center">
      <v-col
        cols="8"
        sm="9"
        md="9"
        lg="8"
        >
      <p class="subtitle-2">Nezobrazuje sa ti tvoja objednávka? Môžeš ju zobraziť pomocou kódu z e-mailu.</p>
      </v-col>
      <v-col cols="5" lg="3">
        <v-btn :small="$vuetify.breakpoint.smAndDown" color="primary" dark @click.stop="dialog = true">
          Zadaj kód objednávky
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="290">
      <v-alert type="error" :value="error1" transition="slide-x-transition">
        Ooops..Nastala neočakávaná chyba
      </v-alert>
      <v-alert type="error" :value="warning1" transition="slide-x-transition">
        Objednávku s daným kódom neevidujeme
      </v-alert>
      <v-alert type="warning" :value="warning2" transition="slide-x-transition">
        Objednávka sa už nachádza v zozname objednávok
      </v-alert>
      <v-card>
         <v-toolbar
          dark
          color="primary"
        >
        <v-spacer></v-spacer> 
          <v-toolbar-title>Vyhľadanie objednávky</v-toolbar-title>
          <v-spacer></v-spacer> 
           <v-btn
            class=""
            icon
            dark
            @click.stop="dialog=false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>   
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="orderNumber"
                label="Kód objednávky"
                required
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="findOrder">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-divider/>
    <order v-for="order in orders" :key="order.code" :order="order" />
  </v-container>
</template>

<script>
import Order from "./Order";
import axios from 'axios';
import store from "../../store/store";

export default {
  name: "UserOrders",
  components: {
    Order
  },
  methods: {
    orderNotExists() {
      this.warning1 = true;
      setTimeout(() => {
        this.warning1 = false;
      }, 3000)
    },
    orderExists() {
      this.warning2 = true;
      setTimeout(() => {
        this.warning2 = false;
      }, 3000)
    },
    unexpectedError() {
      this.error1 = true;
      setTimeout(() => {
        this.error1 = false;
      }, 3000)
    },
    findOrder() {
      let orderInList = this.orders.some(o => o.code == this.orderNumber)
      if(this.orderNumber && !orderInList) {
        this.error = '';
        const params = new URLSearchParams();
        params.append('orderCode', this.orderNumber);
        axios({
          method: 'post',
          url: store.state.url.concat('findOrderByCode.php'),
          data: params
        }).then((response) => {
         
          if(response.data.result == 'ok') {
            this.orders.unshift(response.data);
            this.dialog = false;
          }else if(response.data.result == 'error' && response.data.error == 'notFound'){
            this.orderNotExists()
          }
          else{
            this.unexpectedError()
            this.error = response.data.error;
          }
          this.orderNumber = '';
        });
      }
      else if (orderInList) {
        this.orderExists()
      }
    },

  },
  created() {
      let ordersJSON = localStorage.getItem('orders');
      if(ordersJSON){
        let ordersObject = JSON.parse(ordersJSON)
        for(let value of Object.values(ordersObject)) {
          this.orderNumber = value.code
          this.findOrder()
        }
      }
      this.orders.reverse()
  },
  data: () => ({
    warning1: false,
    warning2: false,
    error1: false,
    dialog: false,
    orderNumber: "",
    error: '',
    orders: [],
    actualOrder: '',
    actualError: ''
  }),
};
</script>
<style>
.no-border {
  border: none !important;
}
</style>
